<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-blurbs element-with-heading" id="praise-for-pat-young">
<div class="heading heading-with-title heading-without-image" id="praise-for-pat-young-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Pat Young</h1>
</div>
</div>
</div>
</div>
<div class="text" id="praise-for-pat-young-text">
<p class="first first-in-chapter first-full-width"><b>"</b>An accomplished plot, plenty of twists and turns and excellent characterisation made this book a real page turner." <b>Kate Moloney - Bibliophile Book Club</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Till the Dust Settles is an intriguing read and one I actually flew through in one sitting." <b>Joanne Robertson - My Chestnut Reading Tree</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Loved it from start to finish." <b>Jo - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"This is a you gotta read book, a brilliant debut. Really excited about this lady’s writing. Superb!" <b>Susan Hampson - Books From Dusk Till Dawn</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"'Till The Dust Settles' is an intense, powerful and heart-wrenching read about love, loss and ultimate devastation." <b>Kaisha Holloway - The Writing Garnet</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"What a clever book, I couldn't put it down." <b>Cariad - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"It was suspenseful, thrilling, addictive, captivating and left me guessing the whole way through." <b>Dash Fan Book Reviews</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"A gripping read to keep you on the edge of your seat." <b>Misfits farm - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"...it has the author's excellent attention to detail and great writing style and I loved the lot." <b>Donna Maguire - Donnas Book Blog</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Another stunning thriller from Pat Young ..." <b>Livia Sbarbaro - Goodreads Reviewer</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"OMG! I have just devoured this book in almost one sitting apart from time to get some shut-eye!" <b>Sharon Bairden - Chapter In My Life</b></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container" style="width: 25.7%">
<img alt="" class="ornamental-break-image" src="images/dog-cut-out.jpg"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">"Pat Young's 'I know where you live' is a thrilling read and makes the reader do abit of soul searching along the way." <b>Susie - Goodreads Reviewer</b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praiseforpatyoung.vue?5f676fcd